<template>
    <div>
        <transition enter-active-class="transition ease-out duration-300 transform" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="transition ease-out duration-300 transform" leave-class="opacity-100" leave-to-class="opacity-0">
            <div v-show="global.loader.isLoading" class="flex grow items-center justify-center top-0 left-0 h-screen z-50 bg-deep-blue text-center -mt-12" :class="[global.loader.overlay ? 'mt-0 absolute w-full' : '']">
                <div>
                    <lottie-animation :width="135" :height="135" :path="global.app.path + 'animations/o_icon_loading_animation.json'" />
                    <h2 class="text-xl font-semibold mt-5">{{ global.loader.label }}</h2>
                    <p class="mt-3" v-if="global.loader.description">{{ global.loader.description }}</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "GlobalLoaderComponent",
    props:{
    },
    data: function () {
        return {};
    },
    computed:{
        ...mapGetters(['global'])
    },
    methods: {
    },
};
</script>
